import { ReactComponent } from '../../../../Utils/Types';
import { SidebarSectionProps } from './SidebarSectionPros';

export function SidebarSection(props: SidebarSectionProps): ReactComponent {
  return (
    <div className="pb-6">
      {props.title ? (
        <h3 className="px-4 pb-3 font-bold text-sm text-text tracking-wider opacity-30">{props.title.toUpperCase()}</h3>
      ) : undefined}
      <div className="space-y-1">{props.children}</div>
    </div>
  );
}
